module.exports = __webpack_public_path__ + "static/img/国家电网展厅.0894b2a8.png";